import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, FormGroup, FormFeedback, Input } from 'reactstrap';
import { LabelText } from '../Utils/Input';
import InputField from '../Utils/InputField';
import SelectField from '../Utils/SelectField';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { dialCodeFocusChange, validatePhoneNumber } from "./../Customers/constants/DocumentTableFunctions";

const PrimaryContactForm = ({
    handleChange,
    handleBlur,
    values,
    touched,
    errors,
    setFieldValue,
    isEdit,
    UserRoleOptions,
    setDialCode,
    dialCode,
    setOnFocus,
    onfocus
}) => {
    const [phoneError, setPhoneError] = useState("");
    const environment = (localStorage.getItem("environment"));
    const isNativeEnvironment = environment === "Native";

    useEffect(() => {
        if (touched.mobile || values.mobile) {
            validatePhone(dialCode);
        }
    }, [dialCode, touched.mobile]);

    const validatePhone = (phoneValue) => {
        if (!phoneValue) {
            setPhoneError("Phone number is required");
        } else if (!isValidPhoneNumber(phoneValue)) {
            setPhoneError("Please enter a valid phone number");
        } else {
            setPhoneError("");
        }
    };

    const handlePhoneFocus = () => {
        setOnFocus(true);
        validatePhone(dialCode);
    };

    const handlePhoneBlur = () => {
        validatePhone(dialCode);
    };

    const handleSSOToggle = (e) => {
        setFieldValue("isSSOUser", e.target.checked);
    };

    return (
        <Row className='p-2'>
            <Col lg={12}>
                <CardBody className="card-body mt-2">
                    <div className="live-preview">
                        <Row className="gy-2 border-1 border p-2">


                            <h4 className="card-title flex-grow-1 mt-2">Admin Details</h4>

                            <Col xxl={3}>

                                <div>
                                    <FormGroup>
                                        <LabelText
                                            htmlFor={"firstName"}
                                            classLabelName={"ms-0 rv-form-label"}
                                            className={"text-danger"}
                                            displayText={"First Name"}
                                            important={"*"}
                                        />
                                        <LabelText
                                            htmlFor={"firstName"}
                                            classLabelName={`d-block ms-0 rv-sub-label ${touched.firstName && errors.firstName
                                                ? "rv-label-danger"
                                                : "rv-label-muted"
                                                }`}
                                            displayText={
                                                touched.firstName && errors.firstName
                                                    ? errors.firstName
                                                    : "Enter your First Name"
                                            }
                                        />
                                        <InputField
                                            name={"firstName"}
                                            type={"text"}
                                            className={"form-control"}
                                            id={"firstName"}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.firstName}
                                            invalid={touched.firstName && errors.firstName ? true : false}
                                        />
                                    </FormGroup>
                                </div>
                            </Col>

                            <Col xxl={3}>
                                <div>
                                    <FormGroup>
                                        <LabelText
                                            htmlFor={"lastName"}
                                            classLabelName={"ms-0 rv-form-label"}
                                            className={"text-danger"}
                                            displayText={"Last Name"}
                                            important={"*"}
                                        />
                                        <LabelText
                                            htmlFor={"lastName"}
                                            classLabelName={`d-block ms-0 rv-sub-label ${touched.lastName && errors.lastName
                                                ? "rv-label-danger"
                                                : "rv-label-muted"
                                                }`}
                                            displayText={
                                                touched.lastName && errors.lastName
                                                    ? errors.lastName
                                                    : "Enter your Last Name"
                                            }
                                        />
                                        <InputField
                                            name={"lastName"}
                                            type={"text"}
                                            className={"form-control"}
                                            id={"lastName"}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.lastName}
                                            invalid={touched.lastName && errors.lastName ? true : false}
                                        />
                                    </FormGroup>
                                </div>
                            </Col>

                            <Col xxl={3}>
                                <div>
                                    <FormGroup>
                                        <LabelText
                                            htmlFor={"email1"}
                                            classLabelName={"ms-0 rv-form-label"}
                                            className={"text-danger"}
                                            displayText={"Email Address"}
                                            important={"*"}
                                        />
                                        <LabelText
                                            htmlFor={"email1"}
                                            classLabelName={`d-block ms-0 rv-sub-label ${touched.email1 && errors.email1
                                                ? "rv-label-danger"
                                                : "rv-label-muted"
                                                }`}
                                            displayText={
                                                touched.email1 && errors.email1
                                                    ? errors.email1
                                                    : "Enter your Email"
                                            }
                                        />
                                        <InputField
                                            name={"email1"}
                                            type={"email"}
                                            className={"form-control"}
                                            id={"email1"}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.email1}
                                            invalid={touched.email1 && errors.email1 ? true : false}
                                        />
                                    </FormGroup>
                                </div>
                            </Col>

                            <Col xxl={3}>
                                <div>
                                    <FormGroup>
                                        <LabelText
                                            htmlFor={"mobile"}
                                            classLabelName={"ms-0 rv-form-label"}
                                            className={"text-danger"}
                                            displayText={"Phone Number"}
                                            important={"*"}
                                        />
                                        <LabelText
                                            htmlFor={"mobile"}
                                            classLabelName={`d-block ms-0 rv-sub-label ${phoneError
                                                ? "rv-label-danger"
                                                : "rv-label-muted"
                                                }`}
                                            displayText={
                                                phoneError
                                                    ? phoneError
                                                    : "Enter your Phone Number"
                                            }
                                        />
                                        <PhoneInput
                                            international
                                            countryCallingCodeEditable={false}
                                            className={`form-control ps-3 ${phoneError ? 'error-input' : ''}`}
                                            onChange={(value) => {
                                                setDialCode(value);
                                                setFieldValue("mobile", value);
                                            }}
                                            onFocus={handlePhoneFocus}
                                            onBlur={handlePhoneBlur}
                                            value={dialCode}
                                        />
                                    </FormGroup>
                                </div>
                            </Col>

                            <Col xxl={3}>
                                <div>
                                    <FormGroup>
                                        <LabelText
                                            htmlFor={"userName"}
                                            classLabelName={"ms-0 rv-form-label"}
                                            className={"text-danger"}
                                            displayText={"User Name"}
                                            important={"*"}
                                        />
                                        <LabelText
                                            htmlFor={"userName"}
                                            classLabelName={`d-block ms-0 rv-sub-label ${touched.userName && errors.userName
                                                ? "rv-label-danger"
                                                : "rv-label-muted"
                                                }`}
                                            displayText={
                                                touched.userName && errors.userName
                                                    ? errors.userName
                                                    : "Enter your User Name"
                                            }
                                        />
                                        <InputField
                                            name={"userName"}
                                            type={"text"}
                                            className={"form-control"}
                                            id={"UserName"}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            value={values.userName}
                                            invalid={touched.userName && errors.userName ? true : false}
                                            disabled={isEdit}
                                        />
                                    </FormGroup>
                                </div>
                            </Col>

                            <Col xxl={3}>
                                <div>
                                    <LabelText
                                        htmlFor={"userRole"}
                                        classLabelName={"ms-0 rv-form-label"}
                                        className={"text-danger"}
                                        displayText={"User Role"}
                                        important={"*"}
                                    />
                                    <LabelText
                                        htmlFor={"userRole"}
                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.userRole && errors.userRole
                                            ? "rv-label-danger"
                                            : "rv-label-muted"
                                            }`}
                                        displayText={
                                            touched.userRole && errors.userRole
                                                ? errors.userRole
                                                : "Select User Role"
                                        }
                                    />
                                    <SelectField
                                        className={(errors.userRole && touched.userRole) ? 'error-input' : ''}
                                        value={values.userRole}
                                        handleChange={(selectedVal) => setFieldValue("userRole", selectedVal)}
                                        isClearable={true}
                                        isDisabled={isEdit}
                                        options={UserRoleOptions}
                                    />
                                </div>
                            </Col>

                            {!isNativeEnvironment && (
                                <Col xxl={3}>
                                    <div>
                                        <FormGroup>
                                            <LabelText
                                                htmlFor={"sso"}
                                                classLabelName={"ms-0 rv-form-label"}
                                                className={"text-danger"}
                                                displayText={"SSO"}
                                            />
                                            <LabelText
                                                htmlFor={"sso"}
                                                classLabelName={"d-block ms-0 rv-sub-label rv-label-muted"}
                                                displayText={"Enable Single Sign-On"}
                                            />
                                            <div className="d-flex align-items-center mt-2">
                                                <FormGroup switch>
                                                    <Input
                                                        type={"switch"}
                                                        className="rv-form-switch-input"
                                                        name="isSSOUser"
                                                        checked={values.isSSOUser || false}
                                                        onChange={handleSSOToggle}
                                                        disabled={isEdit}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </FormGroup>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </div>
                </CardBody>
            </Col>
        </Row>
    );
};

export default PrimaryContactForm;